import { mdiCircleSmall } from '@mdi/js';
import {
  Box,
  Flex,
  Heading,
  Text,
  SkeletonCircle,
  Skeleton,
  Avatar,
} from '@chakra-ui/react';
import {
  formatDate,
  generateMemberDetailsRow,
} from '../utils/memberDetailsUtils';
import { PortalIcon } from 'features/common/components/PortalIcon';

interface IMemberDetailsHeader {
  isLoading: boolean;
  memberName: string;
  lastLogin?: string;
  memberDetails: {
    jobRole?: string | null;
    email?: string;
    phoneNumber?: string | null;
    picture?: string | null;
  };
}
export const MemberDetailsHeader = ({
  memberName,
  memberDetails,
  lastLogin,
  isLoading,
}: IMemberDetailsHeader) => {
  const memberDetailsRow = generateMemberDetailsRow(memberDetails);
  const picture = memberDetails.picture || undefined;
  const hasName = Boolean(memberName);
  const hasPicture = Boolean(picture);
  const hasDetails = memberDetailsRow.length > 0;
  const hasLastLogin = Boolean(lastLogin);

  if (!isLoading && !hasName && !hasPicture && !hasDetails && !hasLastLogin) {
    return null;
  }

  return (
    <Box
      mt='5'
      pb='6'
      mb='8'
      borderBottom='1px solid'
      borderColor='chakra-border-color'
    >
      <Flex>
        {isLoading ? (
          <SkeletonCircle mr='10' boxSize='24' />
        ) : (
          (hasName || hasPicture) && (
            <Avatar
              name={hasName ? memberName : undefined}
              src={picture}
              size='xl'
              mr='6'
            />
          )
        )}
        <Box>
          <Box alignSelf='center'>
            {(isLoading || hasName) && (
              <Skeleton isLoaded={!isLoading}>
                <Heading size='xl' mb='2'>
                  {memberName}
                </Heading>
              </Skeleton>
            )}
            {(isLoading || hasDetails) && (
              <Skeleton isLoaded={!isLoading}>
                {hasDetails && (
                  <Box mb='2'>
                    {memberDetailsRow.map((memberDetail, index) => (
                      <Box key={index} as='span'>
                        <Text as='span'>{memberDetail}</Text>
                        {index < memberDetailsRow.length - 1 && (
                          <PortalIcon
                            path={mdiCircleSmall}
                            mr='4'
                            ml='4'
                            color='neutral'
                          />
                        )}
                      </Box>
                    ))}
                  </Box>
                )}
              </Skeleton>
            )}
            {(isLoading || hasLastLogin) && (
              <Skeleton isLoaded={!isLoading}>
                {hasLastLogin && (
                  <Text variant='subtle'>
                    Last login: {formatDate(lastLogin as string)}
                  </Text>
                )}
              </Skeleton>
            )}
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};
